<template>
  <div class="">
    <div class="flex items-center justify-center w-full pt-8" v-if="gettingOrder">
      <vue-loaders name="square-spin" color="#ed8936" scale=".5"></vue-loaders>
    </div>

    <div
      class="flex items-center justify-between w-full p-12 px-40 mb-12 bg-white"
      v-if="!gettingOrder"
    >
      <div class="flex flex-col items-start">
        <div
          @click="goBack"
          class="flex items-center justify-start font-bold cursor-pointer text-i4m-orange"
        >
          <a-icon type="arrow-left" class="mr-2" />
          <span>Torna a lista ordini</span>
        </div>
        <h2 class="mb-10 text-4xl font-extrabold">Ordine</h2>
      </div>

      <div class="flex flex-col items-end">
        <a-button @click="refresh" class="flex items-center">
          Aggiorna
          <a-icon type="sync" :spin="refreshing" :style="{ color: '#ed8936' }" />
        </a-button>
      </div>
    </div>

    <div v-if="!gettingOrder">
      <a-row>
        <a-col :xs="24" :lg="6">
          <div class="mx-4 bg-white border rounded-md">
            <div
              class="flex items-center justify-between px-4 py-4 bg-i4m-grey rounded-tr-md rounded-tl-md"
            >
              <div class="text-xl font-bold">Dettagli ordine</div>
            </div>

            <div class="flex items-center justify-between h-12 px-6 py-4 border-b">
              <span class="mr-3 opacity-75">Codice:</span>
              <div class="flex items-center text-right">
                <span class="mr-1 font-bold opacity-50">#</span>
                <span class="font-mono font-bold">{{ order.code }}</span>
              </div>
            </div>

            <div class="flex items-center justify-between h-12 px-6 py-4 border-b">
              <span class="mr-3 opacity-75">Stato:</span>

              <div class="flex items-center text-right">
                <span class="font-bold">{{ $t(`status.${order.status}`) }}</span>
              </div>
            </div>

            <div class="flex items-center justify-between h-12 px-6 py-4 border-b">
              <span class="mr-3 opacity-75">Rivenditore:</span>

              <div class="flex items-center text-right">
                <span v-if="order.reseller" class="font-bold">{{ order.reseller.name }}</span>
                <div
                  v-else
                  @click="openResellerSelector"
                  class="font-bold cursor-pointer text-i4m-orange"
                >
                  Assegna
                </div>
              </div>
            </div>

            <div class="flex items-center justify-between px-6 py-4 border-b">
              <span class="mr-3 opacity-75">Compagnia:</span>
              <!-- <img width="96" :src="order.offers[0] && order.offers[0].company.url_logo" /> -->
              <svgicon
                :name="`companies/${order.chosen_offer.company.url_logo}`"
                width="auto"
                height="48"
                :original="true"
                v-if="order.chosen_offer"
              ></svgicon>
            </div>

            <div class="flex items-center justify-between px-6 py-4 border-b">
              <span class="mr-3 opacity-75">Prezzo:</span>
              <euro-value
                v-if="order.chosen_offer && order.chosen_offer.value"
                :value="order.chosen_offer.value"
                class="text-xl font-bold"
                smallerDecimals
                symbolBefore
                hideDecimalsIfZero
              />
            </div>

            <div class="flex items-center justify-between px-6 py-4 border-b">
              <span class="mr-3 opacity-75">Metodo di pagamento:</span>

              <div v-if="!order.paid_on" class="font-bold text-right">Non ancora effettuato</div>
              <div v-else-if="order.payment_method == 'scalapay'">
                <scalapay-logo :width="80"></scalapay-logo>
              </div>
              <div class="font-bold text-right" v-else>Carta di credito</div>
            </div>

            <div class="flex items-center justify-between px-6 py-4 border-b">
              <span class="mr-3 opacity-75">Contraente:</span>
              <span class="font-bold" v-if="order.customer">
                {{ order.customer && order.customer.name + ' ' + order.customer.surname }}
              </span>
              <span v-else class="font-bold">
                {{ order.customer && order.customer.name + ' ' + order.customer.surname }}
              </span>
            </div>

            <div class="flex items-center justify-between px-6 py-4 border-b">
              <span class="mr-3 opacity-75">Numero strumenti:</span>
              <span class="font-bold">{{ order.order_items.length }}</span>
            </div>

            <div class="flex items-center justify-between px-6 py-4 border-b">
              <span class="mr-3 opacity-75">Scadenza:</span>
              <span class="font-bold">-</span>
            </div>
          </div>
        </a-col>
        <!-- right zone -->
        <a-col :xs="24" :lg="18" class="px-4">
          <div
            v-if="order.status === 'approval_neeeded'"
            class="flex items-center justify-start px-8 py-4 mb-12 rounded-md bg-i4m-orange"
          >
            <svgicon
              original
              name="attachment-upload"
              width="78"
              height="78"
              class="mr-4"
            ></svgicon>
            <div class="font-semibold text-white lg:text-xl">
              Il cliente ha caricato i documenti richiesti.
              <br />
              Visionali e approva la polizza.
            </div>

            <div class="flex justify-end flex-grow flex-shrink-0">
              <a-button type="primary" @click="approveOrder" :loading="approving">Approva</a-button>
            </div>
          </div>

          <!-- customer -->
          <div class="mb-12 bg-white border-2 rounded-md border-i4m-grey">
            <div
              class="flex items-center justify-between px-4 py-4 bg-i4m-grey rounded-tr-md rounded-tl-md"
            >
              <div class="text-2xl">Cliente</div>
            </div>

            <div class="px-6">
              <div class="grid items-center h-12 grid-cols-4 px-4 border-b">
                <div class="opacity-75">Nome</div>
                <div class="opacity-75">Email</div>
                <div class="opacity-75">Telefono</div>
                <div class="opacity-75"></div>
              </div>

              <div class="grid items-center h-12 grid-cols-4 px-4" v-if="order.customer">
                <div class="items-center font-bold">
                  {{ order.customer.surname + ' ' + order.customer.name }}
                </div>
                <div class="font-bold">
                  <a :href="`mailto:${order.customer.email}`">{{ order.customer.email }}</a>
                </div>
                <div class="font-bold">
                  <a :href="`tel:${order.customer.phone}`">{{ order.customer.phone }}</a>
                </div>
                <div
                  class="font-bold text-right cursor-pointer text-i4m-orange"
                  @click="showCustomer(order.customer)"
                >
                  Mostra dati completi
                </div>
              </div>
              <div class="grid items-center h-12 grid-cols-4 px-4 opacity-75" v-else>
                Cliente ancora anonimo
              </div>
            </div>
          </div>

          <!-- instruments -->

          <div class="bg-white border-2 rounded-md border-i4m-grey" v-if="quotations.length == 0">
            <div
              class="flex items-center justify-between px-4 py-4 bg-i4m-grey rounded-tr-md rounded-tl-md"
            >
              <div class="text-2xl">Strumenti</div>
            </div>

            <div class="px-6">
              <div class="grid items-center h-12 grid-cols-6 px-4 border-b">
                <div class="opacity-75">Strumento</div>
                <div class="opacity-75">Liutaio</div>
                <div class="opacity-75">Modello</div>
                <div class="opacity-75">Valore (€)</div>
                <div class="opacity-75">Documenti caricati</div>
                <div class="opacity-75"></div>
              </div>

              <div
                v-for="order_item in order.order_items"
                :key="order_item.id"
                class="grid items-center h-12 grid-cols-6 px-4"
              >
                <div class="font-bold">{{ order_item.item_name_copy }}</div>
                <div class="font-bold">{{ order_item.luthier }}</div>
                <div class="font-bold">{{ order_item.model }}</div>
                <div class="font-bold">
                  <euro-value
                    :value="order_item.value"
                    class="font-bold"
                    smallerDecimals
                    symbolBefore
                    hideDecimalsIfZero
                    v-if="order_item.value"
                  />
                </div>
                <div class="font-bold">-</div>
                <div
                  class="font-bold text-right cursor-pointer text-i4m-orange"
                  @click="showSurvey(order_item)"
                  v-if="order_item.survey"
                >
                  Mostra questionario
                </div>
                <div class="text-xs font-bold text-center opacity-50 cursor-pointer" v-else>
                  Nessun questionario disponbile
                </div>
              </div>
            </div>
          </div>

          <h2 v-if="quotations.length > 0" class="mt-8 mb-8 text-3xl">
            Polizze ({{ quotations.length }})
          </h2>

          <div
            v-for="quotation in quotations"
            :key="quotation.id"
            class="mb-6 bg-white border-2 rounded-md border-i4m-grey"
          >
            <div
              class="flex items-center justify-between px-4 py-4 bg-i4m-grey rounded-tr-md rounded-tl-md"
            >
              <div class="text-2xl">Polizza</div>
              <div class="flex items-center">
                <span class="mr-3 opacity-75">Stato:</span>
                <div class="w-4 h-4 mr-2 bg-yellow-400 rounded-full"></div>
                <span class="font-bold">{{ $t(`status.policy${quotation.status}`) }}</span>
                <!-- <a-button class="ml-8 btn-small" type="primary">Visualizza dettagli</a-button> -->
              </div>
            </div>

            <div class="px-6">
              <div class="grid items-center h-12 grid-cols-6 px-4 border-b">
                <div class="opacity-75">Strumento</div>
                <div class="opacity-75">Liutaio/Produttore</div>
                <div class="opacity-75">Modello</div>
                <div class="opacity-75">Valore (€)</div>
                <div class="opacity-75">Documenti caricati</div>
                <div></div>
              </div>

              <div
                v-for="order_item in quotation.order_items"
                :key="order_item.id"
                class="grid items-center h-12 grid-cols-6 px-4"
              >
                <div class="font-bold">{{ order_item.item_name_copy }}</div>
                <div class="font-bold">{{ order_item.luthier }}</div>
                <div class="font-bold">{{ order_item.model }}</div>
                <div class="font-bold">
                  <euro-value
                    :value="order_item.value"
                    class="font-bold"
                    smallerDecimals
                    symbolBefore
                    hideDecimalsIfZero
                  />
                </div>
                <div class="">
                  <div
                    v-if="order_item.attachments && order_item.attachments.length > 0"
                    class="flex flex-col"
                  >
                    <div
                      v-for="att in order_item.attachments"
                      :key="att.id"
                      class="flex flex-no-wrap items-center justify-between"
                    >
                      <a
                        @click="openFile(att.id)"
                        class="font-mono text-sm underline cursor-pointer"
                      >
                        {{ att.name }}
                      </a>
                      <!--                       <a-icon
                        :type="attachmentsDeleting[att.id] ? 'loading' : 'delete'"
                        @click="deleteAttachment(att.id)"
                        class="cursor-pointer"
                        :style="{ fontSize: '16px', color: 'red' }"
                      /> -->
                    </div>
                  </div>
                </div>

                <div
                  class="font-bold text-right cursor-pointer text-i4m-orange"
                  @click="showSurvey(order_item)"
                >
                  Mostra questionario
                </div>
              </div>

              <!-- load quotation documents -->
              <div v-if="quotation.attachments && quotation.attachments.length > 0">
                <div class="grid items-center h-12 grid-cols-1 px-4 border-b">
                  <div class="opacity-75">Documenti allegati</div>
                </div>
                <div
                  v-for="attachment in quotation.attachments"
                  :key="attachment.id"
                  class="grid items-center justify-between grid-cols-2 px-4 py-3 md:grid-cols-5"
                >
                  <div class="col-span-1 font-bold md:col-span-4">{{ attachment.name }}</div>
                  <!--                 <div class="font-bold">
                  {{ attachment.description }}
                </div> -->
                  <div class="flex justify-end col-span-1">
                    <div
                      class="flex items-center justify-center w-32 p-1 rounded-full cursor-pointer bg-i4m-grey-light"
                      @click="openFile(attachment.id)"
                    >
                      <span class="mr-2 font-bold">Visualizza</span>
                      <div class="flex items-center justify-center w-8 h-8 bg-white rounded-full">
                        <svgicon
                          color="#ed8936"
                          name="attachment-upload"
                          width="16"
                          height="16"
                        ></svgicon>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="lg:px-6"></div>
            </div>
          </div>

          <div
            class="mb-6 bg-white border-2 rounded-md border-i4m-grey"
            v-if="order.attachments && order.attachments.length > 0"
          >
            <div
              class="flex items-center justify-between px-4 py-4 bg-i4m-grey rounded-tr-md rounded-tl-md"
            >
              <div class="text-lg lg:text-2xl">
                {{ $t('order.documents.title') }} ({{ order.attachments.length }})
              </div>
              <!--               <a-button class="w-48 ml-8 btn-small" type="primary">
                Scarica tutti
              </a-button> -->
            </div>

            <div class="lg:px-6">
              <div
                v-for="attachment in order.attachments"
                :key="attachment.id"
                class="grid items-center justify-between grid-cols-2 px-4 py-3 md:grid-cols-4"
              >
                <div class="col-span-1 font-bold md:col-span-3">{{ attachment.name }}</div>
                <!--                 <div class="font-bold">
                  {{ attachment.description }}
                </div> -->
                <div class="flex justify-end col-span-1">
                  <div
                    class="flex items-center justify-center w-32 p-1 rounded-full cursor-pointer bg-i4m-grey-light"
                    @click="openFile(attachment.id)"
                  >
                    <span class="mr-2 font-bold">Visualizza</span>
                    <div class="flex items-center justify-center w-8 h-8 bg-white rounded-full">
                      <svgicon
                        color="#ed8936"
                        name="attachment-upload"
                        width="16"
                        height="16"
                      ></svgicon>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </a-col>
      </a-row>
    </div>

    <!-- customer drawer -->
    <a-drawer
      title="Dati cliente"
      placement="right"
      :closable="true"
      :width="400"
      @close="activeCustomer = null"
      :visible="!!activeCustomer"
      :maskClosable="true"
      v-if="activeCustomer"
    >
      <div class="flex items-center justify-end mb-8">
        <span class="mr-3 opacity-75">Stato dati cliente:</span>
        <div
          class="w-4 h-4 mr-2 rounded-full"
          :style="{ backgroundColor: activeCustomer.fiscal_code ? '#52c41a' : 'yellow' }"
        ></div>
        <span class="font-bold">{{ activeCustomer.fiscal_code ? 'Completi' : 'Incompleti' }}</span>
      </div>

      <div
        class="py-4 font-mono border-b"
        v-for="(value, attribute) in activeCustomer"
        :key="attribute"
        v-if="!CUSTOMER_HIDDEN_FIELDS.includes(attribute) && value != null"
      >
        <div class="mb-2 font-bold">{{ $t('fields.' + attribute) }}</div>
        <div class="flex items-center justify-between">
          {{ value }}
          <!--           <a-popover
            :title="'modifica ' + $t('fields.' + attribute)"
            trigger="click"
            v-model="editInfoPopoverOpened[attribute]"
            placement="left"
          >
            <template slot="content">
              <a-form-model
                class="edit-info-popover"
                :model="customerForm"
                @submit="updateCustomer(attribute)"
                @submit.native.prevent
              >
                <a-form-model-item>
                  <a-input v-model="customerForm[attribute]"></a-input>
                </a-form-model-item>
                <a-form-model-item class="text-right">
                  <a-button type="primary" class="mt-6 btn-small" html-type="submit">
                    Salva
                  </a-button>
                </a-form-model-item>
              </a-form-model>
            </template>

            <a-icon
              type="edit"
              class="mr-6 cursor-pointer"
              :style="{ color: '#ed8936', fontSize: '1.3rem' }"
              @click="openEditInfoPopover"
            />
          </a-popover> -->
        </div>
      </div>
    </a-drawer>

    <!-- survey drawer -->
    <a-drawer
      title="Questionario di rischio"
      placement="right"
      :closable="true"
      :width="500"
      @close="activeOrderItem = null"
      :visible="!!activeOrderItem"
      :maskClosable="true"
      v-if="activeOrderItem"
    >
      <div class="flex items-center justify-end mb-8">
        <span class="mr-3 opacity-75">Stato:</span>
        <div
          class="w-4 h-4 mr-2 rounded-full"
          :style="{ backgroundColor: surveyStatus === 'completo' ? '#52c41a' : 'yellow' }"
        ></div>
        <span class="font-bold">{{ surveyStatus }}</span>
      </div>

      <div v-if="!activeOrderItem.survey || Object.keys(activeOrderItem.survey).length === 0">
        Nessuna domanda ancora completata
      </div>
      <!-- 
        v-if="value != 'incidents' && value.search('5_1_what') && value.search('5_1_when')" -->
      <div
        class="font-mono"
        v-for="(key, index) in orderedSuerveyKeys"
        :key="key"
        v-if="key != 'incidents' && key.search('5_1_what') == -1 && key.search('5_1_when') == -1"
      >
        <div v-if="key !== '4_3_3_other'" class="py-4 border-b">
          <div class="mb-2 font-bold">
            {{ key.replace(/_/g, '.') }})
            {{ questions[key].q }}
          </div>
          <div v-if="questions[key].type && questions[key].type == 'date'">
            {{ activeOrderItem.survey[key] | completeDate }}
          </div>
          <div v-else-if="questions[key].type && questions[key].type == 'text'">
            {{ activeOrderItem.survey[key] }}
          </div>
          <div v-else>
            {{ questions[key].a[activeOrderItem.survey[key]] }}
            <span v-if="key === '4_3_3' && activeOrderItem.survey[key] == 1">
              : {{ activeOrderItem.survey['4_3_3_other'] }}
            </span>
          </div>
        </div>
      </div>

      <div class="mt-4 font-extrabold" v-if="surveyHasIncidents">Incidenti</div>
      <div
        class="py-4 font-mono border-b"
        v-for="(incident, key) in this.activeOrderItem.survey['incidents']"
        :key="key"
        v-if="surveyHasIncidents"
      >
        <div class="flex items-center">
          {{ $t(`questions.${incident['what']}`) }} | {{ incident['when'] | completeDate }} |
          <euro-value
            :value="incident['value']"
            class="ml-2"
            smallerDecimals
            symbolBefore
            hideDecimalsIfZero
            v-if="incident['value']"
          />
        </div>
      </div>
    </a-drawer>

    <a-modal
      @cancel="resellerSelectorOpened = false"
      :title="$t('reseller.assingTitle')"
      :visible="resellerSelectorOpened"
    >
      <label class="mr-2">Assegna manualmente a rivenditore:</label>
      <a-select
        v-model="resellerSelected"
        :allowClear="true"
        :placeholder="$t('reseller.select')"
        show-search
        :filter-option="filterResellers"
        style="width: 300px"
      >
        <a-select-option
          :value="String(reseller.id)"
          v-for="reseller in resellers"
          :key="reseller.id"
        >
          {{ reseller.name }}
        </a-select-option>
      </a-select>

      <template slot="footer">
        <a-button key="back" @click="resellerSelectorOpened = false">
          {{ $t('support.cancel') }}
        </a-button>
        <a-button key="submit" type="primary" :loading="savingReseller" @click="saveReseller">
          {{ $t('reseller.assignSubmit') }}
        </a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
import api from '@/api';
import questions from '@/questions';
import utils from '@/utils';
import moment from 'moment';
import 'moment/locale/it';

const CUSTOMER_HIDDEN_FIELDS = ['id', 'order_id', 'created_at', 'updated_at', 'deleted_at'];

export default {
  name: 'BrokerOrder',

  data() {
    return {
      questions,
      CUSTOMER_HIDDEN_FIELDS,
      order: null,
      gettingOrder: true,

      refreshing: false,

      activeOrderItem: null,
      activeCustomer: null,

      // Gracefully handle the "go back to list" button
      fromList: false,

      approving: false,

      marks: {
        0: 'Ha aggiunto gli strumenti',
        15: 'Ha dato i dati personali minimi',
        30: 'Ha completato il questionario di rischio',
        45: "Ha scelto un'offerta",
        60: 'Ha completato i dettagli personali',
        75: "Ha eseguito l'upload dei documenti richiesti",
        90: 'Ha pagato e attivato la polizza',
        100: {
          style: {
            color: '#f50',
          },
          label: <span class="font-mono">Ha pagato e attivato la polizza</span>,
        },
      },

      resellerSelectorOpened: false,
      savingReseller: false,
      resellerSelected: null,
      resellers: [],

      timeline: utils.orderStatuses,

      attachmentsDeleting: {},

      refreshOrderInterval: null,

      editInfoPopoverOpened: {},
      savingCustomer: false,
      customerForm: {},
    };
  },

  created() {
    if (this.$router.currentRoute.query.fromList) {
      this.fromList = true;
      this.$router.replace({ name: 'broker-order' });
    }
  },

  async mounted() {
    this.getOrder();

    this.refreshOrderInterval = setInterval(() => this.getOrder(true), 30 * 1000);
  },

  beforeDestroy() {
    if (this.refreshOrderInterval) {
      window.clearInterval(this.refreshOrderInterval);
    }
  },
  filters: {
    completeDate(value) {
      return moment.utc(value).local().format('DD/MM/YYYY');
    },
  },

  methods: {
    filterResellers(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },

    openResellerSelector() {
      this.resellerSelectorOpened = true;

      api.getResellers({ per_page: 999999 }).then((resp) => {
        this.resellers = resp.data.data;
      });
    },

    async saveReseller() {
      this.savingReseller = true;

      await api.updateOrder(this.order.id, { reseller_id: this.resellerSelected });
      await this.refresh();

      this.savingReseller = false;
      this.resellerSelectorOpened = false;
    },

    async refresh() {
      if (this.refreshing) return false;

      this.$message.loading({
        content: "Aggiornando le informazioni dell'ordine",
        key: 'refreshingOrder',
      });

      this.refreshing = true;
      await this.getOrder(true);

      this.refreshing = false;

      this.$message.success({
        content: 'Informazioni aggiornate!',
        key: 'refreshingOrder',
        duration: 2,
      });
    },

    openEditInfoPopover(attribute) {
      this.$set(this.editInfoPopoverOpened, attribute, true);
    },

    async updateCustomer(attribute) {
      // console.log('updating customer', this.customerForm[attribute]);
      this.editInfoPopoverOpened[attribute] = false;
      this.savingCustomer = true;
    },

    download(id) {
      if (process.env.NODE_ENV === 'production') {
        window.open(`/api/attachments/${id}`, '_blank');
      } else {
        window.open(`http://localhost:8080/api/attachments/${id}`, '_blank');
      }
    },

    openFile(id) {
      if (process.env.NODE_ENV === 'production') {
        window.open(`/api/attachments/${id}/open`, '_blank');
      } else {
        window.open(`http://localhost:8080/api/attachments/${id}/open`, '_blank');
      }
    },

    async approveOrder() {
      this.approving = true;
      await api.editOrder(this.order.id, { status: 'approved' });
      await this.getOrder();
      this.approving = false;
    },

    goBack() {
      if (this.fromList) {
        this.$router.back();
      } else {
        // user refreshed the page manually
        this.$router.push({ name: 'broker-orders' });
      }
    },

    showSurvey(order_item) {
      this.activeOrderItem = order_item;
    },

    showCustomer(customer) {
      this.customerForm = { ...customer };
      this.activeCustomer = customer;
    },

    async getOrder(refreshing) {
      if (!refreshing) this.gettingOrder = true;
      try {
        var resp = await api.getBrokerOrder(this.$router.currentRoute.params.id);
        this.$store.commit('setBrokerLoggedIn', true);
      } catch (error) {
        if (error.response.status === 401) {
          try {
            await api.refreshToken();
            resp = await api.getBrokerOrder(this.$router.currentRoute.params.id);
            this.$store.commit('setBrokerLoggedIn', true);
          } catch (e) {
            // console.log('could not refresh the token');
            this.$router.replace({ name: 'broker-login' });
          }
        }
      }
      this.gettingOrder = false;

      this.order = resp.data;
    },
  },

  computed: {
    quotations() {
      return this.order.chosen_offer ? this.order.chosen_offer.quotations : [];
    },

    surveyStatus() {
      if (!this.activeOrderItem || !this.activeOrderItem.survey) return '';
      return this.activeOrderItem.survey['1_1'] ? 'completo' : 'incompleto';
    },

    orderedSuerveyKeys() {
      let orderedSuerveyKeys = [];
      orderedSuerveyKeys = Object.keys(this.activeOrderItem.survey).sort((key1, key2) => {
        if (key1 < key2) return -1;
        else if (key1 > key2) return +1;
        else return 0;
      });

      return orderedSuerveyKeys;
    },

    surveyHasIncidents() {
      return (
        this.activeOrderItem.survey['incidents'] && this.activeOrderItem.survey['incidents'].length
      );
    },
  },
};
</script>

<style lang="scss" scoped>
// .ant-statistic-content {
//   color: red !important;
// }
.ant-statistic-content {
  font-size: 1.2rem;
}

// <div class="ant-statistic-content"><span class="ant-statistic-content-prefix">€</span><span class="ant-statistic-content-value"><span class="ant-statistic-content-value-int">146</span><span class="ant-statistic-content-value-decimal">,89</span></span></div>
</style>
